import { render, staticRenderFns } from "./CreateSimilarBanner.vue?vue&type=template&id=306a46ce&scoped=true&"
import script from "./CreateSimilarBanner.vue?vue&type=script&lang=js&"
export * from "./CreateSimilarBanner.vue?vue&type=script&lang=js&"
import style0 from "./CreateSimilarBanner.vue?vue&type=style&index=0&id=306a46ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a46ce",
  null
  
)

export default component.exports